import { takeLatest, put, call } from "redux-saga/effects";
import request from "../../../components/Utils/httpHelper";
import { CORE_API } from "../../../config";
import { HTTP_HEADERS } from "../../../constants";
import { Preloading } from "../../../components/UI/Preloader/action";
import { FETCH_SUPPORT_CASE_DETAILS } from "../actionTypes";
import { SUPPORT_AUTOMATION_API, getBackupConfigForTask } from "../constants";
import {
  buildCaseDetails,
  extractApiErrorMessage,
  hasDeletableDataForTask,
} from "../helper";
import {
  fetchSupportCaseDetailsSuccess,
  fetchSupportCaseDetailsFailure,
} from "../action";

export function* fetchSupportCaseDetailsSaga(action) {
  const { caseId, taskType } = action.payload || {};
  const taskConfig = getBackupConfigForTask(taskType);
  const caseDetailsEndpoint =
    taskConfig?.caseDetailsEndpoint ||
    `${SUPPORT_AUTOMATION_API}/case-details`;

  try {
    const response = yield call(
      request,
      `${CORE_API}${caseDetailsEndpoint}`,
      {
        method: "GET",
        headers: HTTP_HEADERS,
        params: { caseId },
        data: "",
      }
    );

    const responseData = response?.data || {};
    const caseDetails = buildCaseDetails(responseData);

    if (!caseDetails.caseId) {
      yield put(
        fetchSupportCaseDetailsFailure({
          taskType,
          message: "Case details not found for the given case ID",
          status: "FAILURE",
        })
      );
      return;
    }

    const hasDeletableData = hasDeletableDataForTask(caseDetails, taskType);

    yield put(
      fetchSupportCaseDetailsSuccess({
        taskType,
        caseDetails,
        noBackupData: !hasDeletableData,
        message: hasDeletableData
          ? null
          : "No deletable data available for this case",
      })
    );
  } catch (err) {
    yield put(
      fetchSupportCaseDetailsFailure({
        taskType,
        message: extractApiErrorMessage(err, "Failed to fetch case details"),
        status: "FAILURE",
      })
    );
  } finally {
    yield put(Preloading(false));
  }
}

export function* watchFetchSupportCaseDetails() {
  yield takeLatest(FETCH_SUPPORT_CASE_DETAILS, fetchSupportCaseDetailsSaga);
}
